import SimpleCarousel from "./SimpleCarousel";
import SimpleCarouselItem from "./SimpleCarouselItem";

export default Object.assign(SimpleCarousel, { Item: SimpleCarouselItem });
